import { useLanguage } from "../contexts/LanguageContext.jsx";
import { getTranslation } from "../translations";

export default function useTranslation() {
  const { language } = useLanguage();

  // Enhanced translation function with variable interpolation support
  const t = (key, variables = null, fallback = null) => {
    const translation = getTranslation(language, key);

    // If no variables to interpolate, return raw translation
    if (!variables) return translation;

    // If translation is the original key and we have a fallback, interpolate the fallback
    if (translation === key && fallback) {
      return interpolateString(fallback, variables);
    }

    // Interpolate variables in the translation string
    return interpolateString(translation, variables);
  };

  // Helper function to replace {variable} with value
  const interpolateString = (string, variables) => {
    if (!variables || typeof string !== "string") return string;

    return string.replace(/\{([^{}]+)\}/g, (match, key) => {
      const value = variables[key];
      return value !== undefined ? value : match;
    });
  };

  return { t, language };
}
